<template>
  <section class="process">
    <!-- Background -->
    <div class="process__bg">
<!--      <img-->
<!--        src="https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=1920&q=80&auto=format&fit=crop"-->
<!--        alt="Crafting process"-->
<!--        class="process__bg-img"-->
<!--      />-->
      <img src="@/assets/images/s4_bg.png" class="process__bg-img">
      <div class="process__overlay" />
    </div>

    <div class="process__inner">
      <div class="process__header">
        <span class="section-label">Craftsmanship</span>
        <h2 class="process__title">Perfume Wiz가 다른 이유</h2>
        <p class="process__subtitle">
          좋은 향은 우연히 만들어지지 않습니다<br>
          기준과 철학이 만듭니다
        </p>
      </div>

      <div class="process__steps">
        <div
          class="process__step"
          v-for="(step, index) in steps"
          :key="index"
        >
          <div class="process__step-number">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="process__step-connector" v-if="index < steps.length - 1" />
          <div class="process__step-content">
            <span class="process__step-icon">{{ step.icon }}</span>
            <h3 class="process__step-title">{{ step.title }}</h3>
            <p class="process__step-desc">{{ step.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProcessSection',
  data() {
    return {
      steps: [
        {
          icon: '💧',
          title: '높은 향료 농도',
          desc: 'Perfume Wiz 디퓨저는\n'
              + '일반 디퓨저보다 높은 향료 함량으로 제작됩니다.\n'
              + '\n'
              + '향이 처음만 강하고 사라지는 것이 아니라\n'
              + '시간이 지나도 공간에 자연스럽게 남습니다.'
        },
        {
          icon: '🧪',
          title: '향의 흐름 설계',
          desc: 'Perfume Wiz 향은\n'
              + 'TOP · MIDDLE · BASE 노트 구조로 설계됩니다.\n'
              + '\n'
              + '처음 향, 공간에 퍼지는 향,\n'
              + '그리고 오래 남는 잔향까지\n'
              + '자연스럽게 이어집니다.'
        },
        {
          icon: '🧴',
          title: '대량 생산하지 않습니다',
          desc: '한 번에 많은 양을 생산하지 않습니다.\n'
              + '\n'
              + '향의 균형이 가장 안정적인 상태로\n'
              + '소량씩 제작하여\n'
              + '향의 완성도를 유지합니다.'
        },
        {
          icon: '⭐',
          title: '겉모습보다 향',
          desc: '우리는 병이나 포장보다\n'
              + '향의 완성도에 비용을 사용합니다.\n'
              + '\n'
              + '그래서 가격은 합리적이지만\n'
              + '향의 기준은 낮추지 않습니다.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables';

.process {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: $bp-mobile) {
    min-height: 100vh;
  }
}

.process__bg {
  position: absolute;
  inset: 0;
  z-index: 0;

  &-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: saturate(0.5) brightness(0.6);
  }
}

.process__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(28, 43, 28, 0.8) 0%, rgba(28, 43, 28, 0.45) 60%, rgba(10, 10, 10, 0.65) 100%)
}

.process__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1280px;
  padding: 0 60px;

  @media (max-width: $bp-mobile) {
    padding: 0 24px;
  }
}

.process__header {
  text-align: center;
  margin-bottom: 60px;

  @media (max-width: $bp-mobile) {
    margin-bottom: 50px;
  }
}

.process__title {
  font-family: $font-heading;
  font-size: clamp(32px, 3.2vw, 48px);
  font-weight: 400;
  color: $color-ivory;
  margin-bottom: 14px;
  @media (max-width: $bp-mobile) {
    font-size: clamp(28px, 3.2vw, 48px);
  }
}

.process__subtitle {
  font-family: $font-body;
  font-size: 14px;
  font-weight: 300;
  color: rgba($color-ivory, 0.65);
  line-height: 1.8;
  @media (max-width: $bp-mobile) {
    font-size: 12px;
  }
}

.process__steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  position: relative;

  @media (max-width: $bp-mobile) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

.process__step {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 24px;

  @media (max-width: $bp-mobile) {
    flex-direction: row;
    text-align: left;
    padding: 0;
    align-items: flex-start;
    gap: 20px;
  }
}

.process__step-number {
  font-family: $font-heading;
  font-size: 13px;
  font-weight: 500;
  color: $color-gold;
  letter-spacing: 0.1em;
  margin-bottom: 20px;
  width: 36px;
  height: 36px;
  border: 1px solid rgba($color-gold, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: $bp-mobile) {
    margin-bottom: 0;
  }
}

.process__step-connector {
  position: absolute;
  top: 18px;
  left: calc(50% + 20px);
  right: calc(-50% + 20px);
  height: 1px;
  background: linear-gradient(to right, rgba($color-gold, 0.4), rgba($color-gold, 0.1));

  @media (max-width: $bp-mobile) {
    display: none;
  }
}

.process__step-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: $bp-mobile) {
    align-items: flex-start;
  }
}

.process__step-icon {
  font-size: 28px;
  margin-bottom: 16px;
  display: block;

  @media (max-width: $bp-mobile) {
    font-size: 18px;
    margin-bottom: 4px;
    display: none;
  }
}

.process__step-title {
  font-family: $font-heading;
  font-size: 22px;
  font-weight: 400;
  color: $color-ivory;
  margin-bottom: 12px;

  @media (max-width: $bp-mobile) {
    font-size: 15px;
    margin-bottom: 4px;
  }
}

.process__step-desc {
  font-family: $font-body;
  font-size: 13px;
  font-weight: 300;
  color: #e6dcc7;
  line-height: 1.7;

  @media (max-width: $bp-mobile) {
    font-size: 12px;
    line-height: 1.6;
  }
}
</style>
